var render = function render(_c,_vm){return _c('img',{ref:_vm.data.ref,class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"src":require("assets/images/wreath.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }